// extracted by mini-css-extract-plugin
export default {"arrowButton":"styles_arrowButton__Mr+Wu"};